export default __webpack_public_path__ + "static/O0205-fc8e797f84e4ceed988e44040a34f619.png";